import { useAuth } from '@/context/AuthContext';
import useHasMounted from '@/hooks/useHasMounted';
import useAnalytics from '@/lib/analytics/useAnalytics';
import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { useSearchParams } from 'next/navigation';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

export const showRewardBannerAtom = atomWithStorage('showRewardBanner', false);

const RewardBanner = () => {
  const [showBanner, setShowBanner] = useAtom(showRewardBannerAtom);
  const hasMounted = useHasMounted();
  const { user } = useAuth();
  const query = useSearchParams();
  const { track } = useAnalytics();
  const { push } = useRouter();

  useEffect(() => {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    const rewardfulCallback = (window as any).rewardful;

    if (!rewardfulCallback) return;

    rewardfulCallback('ready', () => {
      const refVia = query?.get('via');
      // biome-ignore lint/suspicious/noExplicitAny: <explanation>
      if ((window as any).Rewardful.referral && refVia) {
        if (!showBanner) {
          setShowBanner(true);
          track('referral_link_visited');
        }
        if (user) {
          push(`/new?via=${refVia}`);
        }
      }
    });
  }, [query]);

  const handleClose = () => {
    setShowBanner(false);
  };

  if (!showBanner || !hasMounted) return null;

  return (
    <div className="left-0 top-0 sticky w-full text-center h-9 max-sm:text-xs text-badgeBlue text-sm font-semibold bg-badgeLightBlue p-2 z-[49] flex justify-between items-center">
      <div className="text-center flex-grow">
        <span>$10 discount applied at checkout</span>
      </div>
      <button
        onClick={handleClose}
        className="bg-transparent border-none cursor-pointer p-2 text-xl font-medium"
      >
        &times;
      </button>
    </div>
  );
};

export default RewardBanner;
